import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1 className="text-center text-5xl mt-72 font-bold text-primary h-screen">404 NOT FOUND!</h1>
        </div>
    );
};

export default NotFound;